import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
  this.interviewStartValidaton = function () {
    const dictonary = {
      custom: {
        DateCommence: {
          required: () => t.t(dictEnum.LBL_Commencement) + t.t(dictEnum.WARN_IsRequired)
        },
        JobName: {
          required: () => t.t(dictEnum.LBL_Position) + t.t(dictEnum.WARN_IsRequired)
        },
        BasicSalary: {
          required: () => t.t(dictEnum.LBL_BasicSalary) + t.t(dictEnum.WARN_IsRequired),
          integer: () => t.t(dictEnum.LBL_BasicSalary)
        },
        SalPayCycle: {
          required: () => t.t(dictEnum.LBL_SalPayCycle) + t.t(dictEnum.WARN_IsRequired)
        },
        Allowance: {
          required: () => t.t(dictEnum.LBL_Allowance) + t.t(dictEnum.WARN_IsRequired),
          integer: () => t.t(dictEnum.LBL_Allowance)
        },
        PayCycle: {
          required: () => t.t(dictEnum.LBL_SalPayCycle) + t.t(dictEnum.WARN_IsRequired)
        },
      }
    };
    Validator.localize('en', dictonary);
  }
}



// WEBPACK FOOTER //
// ./src/components/S090000-Candidate/S090300-JobInterviewStart/S090300-InterviewStart/S090300-InterviewStartValidaton.js